// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.card-image {
  max-width: 100%;
  height: auto;
  width: 250px;
}

.card-title {
  color: #000000;
  font-size: 1.375rem;
  line-height: 24px;
  font-weight: 700;
  margin: 15px 0 0 0;
}

.card-subtitle {
  color: #666666;
  font-size: 1.063rem;
  line-height: 1.5rem;
}

.certificate-card {
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  padding: 1.5rem;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
  transition: all 0.3s ease;
}

.certificate-detail-div {
  text-align: center;
}

.certificate-card:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;
}

.dark-mode.certificate-card:hover {
  box-shadow: rgba(255, 255, 255, 0.2) 0px 20px 30px -10px;
}

.certificate-image-div {
  position: relative;
  height: 250px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.achievement-cards-div {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 1rem 1rem;
  gap: 1rem 1rem;
}

.certificate-card-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}

.certificate-card-footer span.certificate-tag {
  background: #55198b;
  color: #f5f2f4;
  vertical-align: middle;
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  white-space: nowrap;
  line-height: 1.5;
  margin: 0 0.5rem 0.5rem 0;
  padding: 0 0.75em;
  cursor: pointer;
  transition: 0.2s ease-in;
}

span.certificate-tag:hover {
  background: #8c43ce;
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/achievementCard/AchievementCard.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,eAAA;EACA,YAAA;EACA,YAAA;AAEF;;AAAA;EACE,cDEW;ECDX,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAGF;;AADA;EACE,cDFa;ECGb,mBAAA;EACA,mBAAA;AAIF;;AAFA;EACE,oCDciB;ECbjB,kDAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EAGA,yBAAA;AAKF;;AAHA;EACE,kBAAA;AAMF;;AAJA;EACE,kDAAA;AAOF;;AALA;EACE,wDAAA;AAQF;;AANA;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AASF;;AAPA;EACE,aAAA;EACA,2DAAA;EACA,mBAAA;EAAA,cAAA;AAUF;;AARA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAWF;;AATA;EACE,mBDrDY;ECsDZ,cDxBiB;ECyBjB,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,wBAAA;AAYF;;AAVA;EACE,mBDrEY;ACkFd","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.card-image {\n  max-width: 100%;\n  height: auto;\n  width: 250px;\n}\n.card-title {\n  color: $titleColor;\n  font-size: 1.375rem;\n  line-height: 24px;\n  font-weight: 700;\n  margin: 15px 0 0 0;\n}\n.card-subtitle {\n  color: $cardSubtitle;\n  font-size: 1.063rem;\n  line-height: 1.5rem;\n}\n.certificate-card {\n  background-color: $lightBackground2;\n  box-shadow: $lightBoxShadowDark 0px 10px 30px -15px;\n  padding: 1.5rem;\n  border-radius: 10px;\n  border: 1px solid $lightBorder1;\n  -webkit-transition: all 0.3s ease;\n  -o-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n.certificate-detail-div {\n  text-align: center;\n}\n.certificate-card:hover {\n  box-shadow: $lightBoxShadowDark 0px 20px 30px -10px;\n}\n.dark-mode.certificate-card:hover {\n  box-shadow: $achievementCertificateCardHoverDark 0px 20px 30px -10px;\n}\n.certificate-image-div {\n  position: relative;\n  height: 250px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.achievement-cards-div {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem 1rem;\n}\n.certificate-card-footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.certificate-card-footer span.certificate-tag {\n  background: $buttonColor;\n  color: $lightBackground3;\n  vertical-align: middle;\n  align-items: center;\n  border-radius: 4px;\n  display: inline-flex;\n  font-size: 0.75rem;\n  height: 2em;\n  justify-content: center;\n  white-space: nowrap;\n  line-height: 1.5;\n  margin: 0 0.5rem 0.5rem 0;\n  padding: 0 0.75em;\n  cursor: pointer;\n  transition: 0.2s ease-in;\n}\nspan.certificate-tag:hover {\n  background: $buttonHover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
